import { LoginWorkflowLayout } from "components/app/login-workflow-layout";
import { SupportEmailLink } from "components/app/support-email-link";
import { InlineBanner } from "components/ui/inline-banner";
import React from "react";

export const OutlookAdminConsentNotApproved: React.FC = () => (
    <LoginWorkflowLayout title="Nothing was approved">
        <InlineBanner type="error">
            Microsoft sent you back without recording an approval. This usually means the
            approval was declined or the sign-in was cancelled. Open the link again to
            start over, or contact{" "}
            <SupportEmailLink label="support" subject="Microsoft 365 admin approval" />.
        </InlineBanner>
    </LoginWorkflowLayout>
);
